import React, { useEffect, useState } from 'react';
import { SapperLogo } from './SapperLogo';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-sapper-dark/95 backdrop-blur-md border-b border-sapper-olive/30 py-2' : 'bg-transparent py-4'}`} data-id="element-146">
      <div className="container mx-auto px-4 sm:px-6 flex items-center justify-between" data-id="element-147">
        {/* Logo */}
        <a href="#" className="flex items-center" aria-label="Sapper HVAC home" data-id="element-148">
          <SapperLogo className="h-12 sm:h-14 w-auto" data-id="element-149" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-150">
          <a href="#services" className="font-mono text-sm text-sapper-white hover:text-sapper-red transition-colors tracking-wider" data-id="element-151">
            SERVICES
          </a>
          <a href="#areas" className="font-mono text-sm text-sapper-white hover:text-sapper-red transition-colors tracking-wider" data-id="element-152">
            AREAS
          </a>
          <a href="#missions" className="font-mono text-sm text-sapper-white hover:text-sapper-red transition-colors tracking-wider" data-id="element-153">
            MISSIONS
          </a>
          <a href="#reviews" className="font-mono text-sm text-sapper-white hover:text-sapper-red transition-colors tracking-wider" data-id="element-154">
            REVIEWS
          </a>
        </nav>

        {/* CTA & Mobile Toggle */}
        <div className="flex items-center gap-4" data-id="element-155">
          <a href="tel:4805550199" className="hidden sm:flex items-center gap-2 font-mono text-sm font-bold text-sapper-white border border-sapper-olive px-4 py-2 hover:bg-sapper-olive/20 transition-colors" data-id="element-156">
            <Phone className="w-4 h-4 text-sapper-red" data-id="element-157" />
            (480) 555-0199
          </a>
          <button className="md:hidden text-sapper-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-158">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-159" /> : <Menu className="w-6 h-6" data-id="element-160" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-sapper-dark border-b border-sapper-olive/30 py-4 px-4 flex flex-col gap-4 shadow-2xl" data-id="element-161">
          <a href="#services" className="font-mono text-lg text-sapper-white hover:text-sapper-red py-2 border-b border-sapper-olive/20" data-id="element-162">
            SERVICES
          </a>
          <a href="#areas" className="font-mono text-lg text-sapper-white hover:text-sapper-red py-2 border-b border-sapper-olive/20" data-id="element-163">
            AREAS
          </a>
          <a href="#missions" className="font-mono text-lg text-sapper-white hover:text-sapper-red py-2 border-b border-sapper-olive/20" data-id="element-164">
            MISSIONS
          </a>
          <a href="#reviews" className="font-mono text-lg text-sapper-white hover:text-sapper-red py-2 border-b border-sapper-olive/20" data-id="element-165">
            REVIEWS
          </a>
          <a href="tel:4805550199" className="flex items-center justify-center gap-2 font-mono text-lg font-bold text-sapper-white bg-sapper-red px-4 py-3 mt-2" data-id="element-166">
            <Phone className="w-5 h-5" data-id="element-167" />
            CALL (480) 555-0199
          </a>
        </div>}
    </header>;
}